var map = {
	"./champ.png": 44094,
	"./dagelan.png": 40480,
	"./johng.png": 38615,
	"./kai.png": 28055,
	"./kevin.png": 10678,
	"./playhouse.png": 46996,
	"./tania.png": 81030,
	"./wimo.png": 4868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19098;